import React ,{useEffect} from 'react';
import { useParams } from 'react-router-dom';
import Header from '../../components/Headers/Header';
import {initPixel,pixelPageView } from '../../utils/Facebook/Pixel';
import './thankyou.scss';


const ThankYou = () => {
  useEffect(()=>{
   /*  initPixel('1721036488202580')
    pixelPageView() */
   

  },[])

/*   let { username } = useParams(); */
  return (
    <>
      <div className="thankyou_main">
        <section className="thankyou">
          <div className="thankyou-title">
            <p>¡Bienvenido abogado!</p>
          </div>
          <div className="thankyou-subtitle">
            <p>
              En breve, un representante de nuestro equipo se pondrá en contacto para brindarte más información.
            </p>
          </div>
          <div className="thankyou-wrapper">
            <div className="thankyou-image">
              <img src="/img/thankyou/user_operator.png" alt="" />
            </div>
            <div className="thankyou-description">
              <ul>
                <li>
                  Intégrate a la comunidad con los mejores abogados en línea
                </li>
                <li>
                  Aumenta tus ingresos
                </li>
                <li>
                  Genera nuevos clientes
                </li>
              </ul>
            </div>
          </div>
          <img height="1" width="1" style={{display:'none'}} alt="" src="https://px.ads.linkedin.com/collect/?pid=1733506&conversionId=1792842&fmt=gif"  />
        </section>
      </div>
    </>
  );
};

export default ThankYou;
